import type { PaginationParams } from '../types/Pagination.types';
import { z } from 'zod';
import { MediaDtoSchema } from '../media/media.schema';
import { PageContentDtoSchema } from '../system-pages';
import { PaginationParamsSchema } from '../types/Pagination.types';
import { CategoryGroupKey } from './types/categoryGroupKey';

export const CategoryDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  alias: z.string(),
  cover: MediaDtoSchema.nullish(),
  description: z.string().nullish().transform(v => v ?? ''),
  order: z.number(),
  mobileCover: MediaDtoSchema.nullish(),
  desktopCover: MediaDtoSchema.nullish(),
  mobileListCover: MediaDtoSchema.nullish(),
  isActive: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  pageContent: PageContentDtoSchema.nullish(),
}).describe('CategoryDtoSchema');

export const CategoryListItemDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  alias: z.string(),
  order: z.number(),
  isActive: z.boolean(),
  cover: MediaDtoSchema.nullish().transform(v => v ?? null),
  mobileListCover: MediaDtoSchema.nullish().transform(v => v ?? null),
}).describe('CategoryListItemDtoSchema');

// TODO: need to make a generic filter schema for all entities, because it is the same for all entities
// currently it is only for categories, but in the future it will be used for other entities as well
const StringFilterSchema = z.union([
  z.string(),
  z.object({
    $cont: z.string().optional(),
    $ne: z.string().optional(),
  }),
]);

export const CategoryFiltersSchema = z.object({
  name: StringFilterSchema.optional(),
  alias: StringFilterSchema.optional(),
  order: z.number().optional(),
  isActive: z.boolean().optional(),
  groupKey: z.nativeEnum(CategoryGroupKey).optional(),
}).optional();

export const CategoryParamsSchema = PaginationParamsSchema(CategoryFiltersSchema);

export type CategoryDto = z.infer<typeof CategoryDtoSchema>;
export type CategoryListItemDto = z.infer<typeof CategoryListItemDtoSchema>;

export type CategoryListParams = PaginationParams<typeof CategoryParamsSchema>;
